<template>
  <div class="relative">
    <div class="q-table-wrapper">
      <div>
        <table class="q-table" :class="{ 'q-table-border': border }" border="1" cellpadding="0" cellspacing="0">
          <thead ref="tableHead">
            <tr>
              <th key="first" v-if="!disabledRow">
                <template v-if="rowDesc">
                  <div v-html="rowDesc.richText" :style="getColStyle(0)"></div>
                </template>
              </th>
              <th v-for="(col, index) in columns" :key="col.id" class="relative" :style="getColStyle(index + 1)">
                <div :style="getColStyle(index + 1)">
                  <template v-if="hasColumnHeader">
                    <slot name="column-header" :col="col"></slot>
                  </template>
                  <template v-else>
                    <div class="column-title-wrap">
                      <div :class="[col.required && showRequired ? 'pl-4 relative' : '']">
                        <span style="left: 4px" class="text-red absolute left-0 top-0 py-2" v-if="col.required && showRequired"
                          >*</span
                        >
                        <div class="p-2" v-html="col.content.richText"></div>
                      </div>
                    </div>
                  </template>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ref="tr" v-for="(row, index) in rows" :key="row[rowKey]">
              <td v-if="!disabledRow" :key="row[rowKey]" class="relative">
                <div class="row-title-wrap py-2" :style="getColStyle(0)">
                  <div class="px-2" v-html="row.content.richText"></div>
                </div>
              </td>
              <td
                class="table-content"
                v-for="(item, colIndex) in row.cols || columns"
                :key="item.id"
                :class="{ relative: view }"
              >
                <slot name="content" :row="row" :col="item" :colIndex="colIndex" :rowIndex="index"></slot>
                <template v-if="view">
                  <div class="absolute inset-0 z-30"></div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="absolute left-0 top-0 bg-white z-10 max-w-full overflow-x-auto" ref="fixedLeftCol" v-if="!disabledRow">
        <table class="q-table" :class="{ 'q-table-border': border }" border="1" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <td ref="fixedHead" :style="getColStyle(0)">
                <template v-if="rowDesc">
                  <div v-html="rowDesc.richText"></div>
                </template>
                <template v-else>
                  <span></span>
                </template>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr ref="fixedTr" v-for="row in rows" :key="row[rowKey]">
              <td v-if="!disabledRow" :key="row[rowKey]" class="relative">
                <div class="row-title-wrap py-2" :style="getColStyle(0)">
                  <div class="px-2" v-html="row.content.richText"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QTable',
  props: {
    disabledRow: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    border: {
      type: Boolean,
      default: true
    },
    rowKey: {
      type: String,
      default: 'row_id'
    },
    showRequired: {
      type: Boolean,
      default: false
    },
    view: {
      type: Boolean,
      default: false
    },
    rowDesc: {
      type: Object,
      default: null
    },
    widths: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasColumnHeader() {
      return this.$scopedSlots['column-header']
    },
    hasColumnContent() {
      return this.$scopedSlots['column-content']
    }
  },
  methods: {
    getColStyle(idx) {
      const width = this.widths[idx]
      if (!width) {
        if (idx === 0) {
          return {
            width: '200px'
          }
        } else {
          return {
            whiteSpace: 'nowrap'
          }
        }
      }
      return {
        width: width
      }
    },
    initTable() {
      if (this.disabledRow) return

      this.$refs.fixedHead.style.height = this.getHeaderHeight() - 1 + 'px'
      const trs = this.$refs.tr
      const fixedTrs = this.$refs.fixedTr
      for (let i = 0; i < trs.length; i++) {
        let tr = trs[i]
        let fixedTr = fixedTrs[i]
        const s = tr.currentStyle ? tr.currentStyle : window.getComputedStyle(tr, null)
        fixedTr.style.height = parseFloat(s.height) + 1 + 'px'
      }
    },
    getHeaderHeight() {
      const headEl = this.$refs.tableHead
      const s = headEl.currentStyle ? headEl.currentStyle : window.getComputedStyle(headEl, null)
      return parseFloat(s.height)
    },
    getRowsHeight() {
      const trs = this.$refs.tr
      const results = []
      for (let i = 0; i < trs.length; i++) {
        let tr = trs[i]
        const s = tr.currentStyle ? tr.currentStyle : window.getComputedStyle(tr, null)
        results.push(parseFloat(s.height) + 1)
      }
      return results
    }
  },
  mounted() {
    this.initTable()
    const promises = []
    let imgList = this.$refs.tableHead.getElementsByTagName('img')
    for (let i = 0; i < imgList.length; i++) {
      const img = imgList[i]
      promises.push(
        new Promise(resolve => {
          img.onload = function () {
            resolve()
          }
        })
      )
    }
    if (promises.length) {
      Promise.all(promises).then(() => {
        this.initTable()
      })
    }
  }
}
</script>
<style lang="scss">
.q-table-wrapper {
  max-width: 100%;
  overflow-x: auto;
  //.row-title-wrap,
  //.column-title-wrap {
  //  width: 242px;
  //  @apply whitespace-normal;
  //}
}

.q-table-wrapper {
  thead {
    background-color: #fafafa;
  }
}

.q-table {
  text-align: left;
  max-width: 100%;

  &.q-table-border {
    th,
    td {
      @apply border border-border-gray border-solid;
    }
  }

  tr {
    @apply border-b border-border-gray border-solid;
  }

  th,
  td {
    font-weight: normal;
    @apply text-black text-opacity-85 text-medium leading-base;
    border-collapse: collapse;
    min-width: 120px;
  }

  .table-content {
    & > * {
      width: 100%;
      height: 100%;
      padding: 10px 8px;
      box-sizing: border-box;

      &.use-hover {
        &:hover {
          cursor: pointer;
          background-color: rgba(199, 199, 199, 0.2);
        }
      }
    }
  }
}
</style>
